var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9", attrs: { id: "main" } }, [
              _c("div", { staticClass: "container shortcode travel-ideas" }, [
                _c("h1", { staticClass: "idea-title" }, [
                  _vm._m(0),
                  _vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale]) + ":"),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _vm._m(7),
              _vm._v(" "),
              _vm._m(8),
              _vm._v(" "),
              _vm._m(9),
              _vm._v(" "),
              _vm._m(10),
              _vm._v(" "),
              _vm._m(11),
              _vm._v(" "),
              _vm._m(12),
              _vm._v(" "),
              _vm._m(13),
              _vm._v(" "),
              _vm._m(14),
              _vm._v(" "),
              _vm._m(15),
              _vm._v(" "),
              _vm._m(16),
              _vm._v(" "),
              _vm._m(17),
              _vm._v(" "),
              _vm._m(18),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar col-md-3" },
              [_c("sdr-aboutsundair-box"), _vm._v(" "), _c("sdr-contact-box")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_12.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "SUNDAIR startet ab Juli wieder zu den schönsten Urlaubszielen"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 16.06.2020 ")]),
                    _vm._v(
                      " – Die Flugzeuge der Stralsunder Fluggesellschaft SUNDAIR heben in\n                                                Kürze wieder von ihren Heimatbasen Kassel, Bremen, Dresden sowie Berlin-Tegel zu\n                                                Urlaubszielen am Mittelmeer, dem Schwarzen Meer sowie am Atlantischen Ozean ab.\n                                                Reisende können sich auf die griechische Sonne in den Destinationen Kreta, Kos, Rhodos sowie\n                                                Korfu freuen. Am Schwarzen Meer laden die Strände in Varna und Burgas zur Erholung ein.\n                                                Ebenfalls im neuen Sommerflugplan steht die türkische Riviera mit Antalya. In Spanien bedient\n                                                SUNDAIR die vielfältige Kanareninsel Fuerteventura, sowie die Lieblingsinsel der Deutschen:\n                                                Mallorca. Reisen mit SUNDAIR können im Reisebüro, über Reiseveranstalter sowie über die\n                                                Website "
                    ),
                    _c("a", { attrs: { href: "https://www.sundair.com" } }, [
                      _vm._v("www.sundair.com"),
                    ]),
                    _vm._v(
                      " gebucht werden.\n                                                "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Wir freuen uns darauf unsere Gäste schon bald wieder in ihren wohlverdienten Urlaub\n                                                fliegen zu können. Es war uns wichtig, dass bei der Erstellung des neuen Sommerflugplans\n                                                unseren Passagieren eine breite Vielfalt an Destinationen zur Erholung oder für den\n                                                Aktivurlaub angeboten werden. Wir werden im Laufe des Sommers weitere Ziele des\n                                                ursprünglichen Angebots sowie Erweiterungen von Frequenzen prüfen“ "
                      ),
                    ]),
                    _vm._v(
                      ", so Marcos Rossello,\n                                                Geschäftsführer der Sundair GmbH.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v("Schutzmaßnahmen während der gesamten Flugreise"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                                Auch in Zeiten von Corona sorgt SUNDAIR dafür, dass alle Gäste sicher in den Urlaub starten.\n                                                Flughäfen und Airlines setzen hierbei eine Reihe von vorbeugenden Schutzmaßnahmen für\n                                                die gesamte Flugreise ein, um diese vom Betreten des Terminals bis zur Ankunft am Zielort so\n                                                sicher wie möglich zu gestalten. An Bord aller SUNDAIR Flüge gilt zunächst für Gäste sowie für\n                                                die Kabinenbesatzungen eine Mund-Nasenschutz-Pflicht. Weiterhin wurden die Ein- und\n                                                Aussteigeprozesse entsprechend der besonderen aktuellen Situation angepasst. Dies\n                                                bedeutet ein Einstieg in kleineren Gruppen und eine erhöhte Anzahl an Bussen. Nach\n                                                Möglichkeit wird ein Einsteigen am Gebäude ermöglicht. Zudem erfolgt eine intensive\n                                                Reinigung der Oberflächen nach den Flügen. Wir bitten unsere Gäste sich während der\n                                                gesamten Reise an die geltenden Hygienevorschriften zu halten und die\n                                                Einreisebestimmungen des jeweiligen Zielorts sowie die Bestimmungen bei der Rückkehr nach\n                                                Deutschland zu beachten.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("b", [
                    _vm._v("Zielgebietsübersicht SUNDAIR – Sommer 2020"),
                  ]),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c("table", { staticStyle: { width: "100%" } }, [
                    _c("tr", [
                      _c("td", [_c("b", [_vm._v("Kassel")])]),
                      _vm._v(" "),
                      _c("td", [_c("b", [_vm._v("Bremen")])]),
                      _vm._v(" "),
                      _c("td", [_c("b", [_vm._v("Dresden")])]),
                      _vm._v(" "),
                      _c("td", [_c("b", [_vm._v("Berlin")])]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("Palma de Mallorca"),
                        _c("br"),
                        _vm._v("(ab 06. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Palma de Mallorca"),
                        _c("br"),
                        _vm._v("(ab 17. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Palma de Mallorca"),
                        _c("br"),
                        _vm._v("(ab 18. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Kreta"),
                        _c("br"),
                        _vm._v("(ab 04. Juli)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("Kreta"),
                        _c("br"),
                        _vm._v("(ab 04. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Fuerteventura"),
                        _c("br"),
                        _vm._v("(ab 17. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Fuerteventura"),
                        _c("br"),
                        _vm._v("(ab 23. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Kos"),
                        _c("br"),
                        _vm._v("(ab 02. Juli)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("Antalya"),
                        _c("br"),
                        _vm._v("(ab 18. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Kreta"),
                        _c("br"),
                        _vm._v("(ab 04. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Kreta"),
                        _c("br"),
                        _vm._v("(ab 12. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Rhodos"),
                        _c("br"),
                        _vm._v("(ab 02. Juli)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Kos"),
                        _c("br"),
                        _vm._v("(ab 16. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Kos"),
                        _c("br"),
                        _vm._v("(ab 19. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Varna"),
                        _c("br"),
                        _vm._v("(ab 06. Juli)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Rhodos"),
                        _c("br"),
                        _vm._v("(ab 14. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Rhodos"),
                        _c("br"),
                        _vm._v("(ab 04. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Burgas"),
                        _c("br"),
                        _vm._v("(ab 01. Juli)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Antalya"),
                        _c("br"),
                        _vm._v("(ab 15. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Korfu"),
                        _c("br"),
                        _vm._v("(ab 21. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Beirut"),
                        _c("br"),
                        _vm._v("(ab 01. Juli)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Varna"),
                        _c("br"),
                        _vm._v("(ab 18. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Korfu"),
                        _c("br"),
                        _vm._v("(ab 04. Juli)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("Antalya"),
                        _c("br"),
                        _vm._v("(ab 17. Juli)"),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("p", [
                    _vm._v(
                      "Ziele vorbehaltlich Änderungen und Beachtung der aktuellen behördlichen Bestimmungen sowie Regularien!"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("br"),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("15.06.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2020")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_11.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "schauinsland-reisen und SUNDAIR präsentieren den Katta-Flieger"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Duisburg/Stralsund, 21. Februar 2020")]),
                    _vm._v(
                      " – Der neue Flieger der Sundair ist bunt, kindgerecht\n                                                und ein echter Hingucker. Die Rede ist vom Katta-Flieger, der ab Anfang Mai in Bremen\n                                                stationiert sein wird, und Urlauber mit einer ganz besonders auffälligen Maschine nach\n                                                Mallorca, Kreta, Rhodos, Antalya, Fuerteventura und Kos bringen wird. Vorab wird das neue\n                                                Flottenmitglied bereits an anderen Stationen zu Gast sein. Der Airbus A320-214 wurde nach\n                                                der Überführung in den Niederlanden lackiert und in Bremen mit Katta, Ingo Flamingo, Adele\n                                                Garnele und ihren Freunden beklebt. Das Ergebnis: Eine kleine Geschichte, die Urlaubern\n                                                das Warten am Gate verkürzen soll und neugierig macht.\n\n                                                "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "Katta, der kleine Halbaffe, ist bereits seit einigen Jahren das Maskottchen von schauinslandreisen und der Held der Geschichtsreihe „Kattas Welt“. Die unterhaltsamen Geschichten\n                                                sollen kleine Urlauber zu Weltentdeckern machen und sie für fremde Kulturen und Länder\n                                                begeistern. Vor einem Jahr begeisterte Katta und seine Freunde über 20.000 Besucher beim\n                                                Musical „Katta – Das Kindermusical. Die Reise zur leuchtenden Banane“ und jetzt schicken\n                                                sie ihn sogar in die Luft. "
                    ),
                    _c("i", [
                      _vm._v(
                        "„Die Erfolgsgeschichte von ‚Kattas Welt‘ ist einfach unglaublich. Erst\n                                                der Einstieg der Katta CD in die internationalen Albumcharts, dann das eigene\n                                                Animationskonzept mit ‚Katta macht Urlaub‘ und jetzt sorgen wir dafür, dass Katta bereits auf\n                                                dem Flug für Urlaubsfreude sorgt“"
                      ),
                    ]),
                    _vm._v(
                      ", so Andreas Rüttgers, Leiter Touristik bei schauinslandreisen.\n\n                                                "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "Marcos Rossello, Geschäftsführer der Sundair, freut sich über den außergewöhnlichen\n                                                Flottenzuwachs: "
                    ),
                    _c("i", [
                      _vm._v(
                        "„Sobald ein Flieger mit besonderer Lackierung ans Gate rollt, zaubert er\n                                                den Passagieren, Besuchern und Flughafenmitarbeitern ein Lächeln ins Gesicht. Von\n                                                diesem positiven Effekt können auch wir als noch junge Airline profitieren und so auf\n                                                charmante Art und Weise unsere Bekanntheit weiter steigern.“"
                      ),
                    ]),
                    _c("br"),
                    _c("br"),
                  ]),
                  _c("br"),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("21.02.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2020")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_10.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "Nonstop nach Korfu: SUNDAIR erweitert Angebot am Flughafen Dresden"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 18.22.2019 ")]),
                    _vm._v(
                      " – In der kommenden Sommersaison stockt die Fluggesellschaft SUNDAIR ihr Angebot ab Dresden auf und fliegt nun auch nach Korfu.\n                                                Vom 5. Mai bis 27. Oktober 2020 bringt die Airline immer dienstags Urlauber auf die sonnenreiche Insel vor der griechischen Nordwestküste.\n                                                Für das neue Ziel sind bereits Pauschalreisen buchbar. Flugtickets erhalten Erholungssuchende demnächst auf "
                    ),
                    _c("a", { attrs: { href: "https://www.sundair.com" } }, [
                      _vm._v("www.sundair.com"),
                    ]),
                    _vm._v(
                      ".\n                                                "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Mit Korfu erweitern wir im Sommer 2020 unser Streckenetz ab Dresden um eine weitere attraktive griechische Destination.\n                                                Jeden Dienstag bringt unsere SUNDAIR-Maschine Reisende aus Sachsen und der Umgebung nach Korfu. Wir freuen uns, dass wir neben Rhodos, Kos und Heraklion ab dem nächsten Sommerflugplan vier Ziele auf den griechischen Inseln anfliegen werden“,"
                      ),
                    ]),
                    _vm._v(
                      "\n                                                so Marcos Rossello, Geschäftsführer von SUNDAIR.\n                                                "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                SUNDAIR steuert im Sommerflugplan 2020 insgesamt neun Ziele von Dresden an. Am Airport der sächsischen Landeshauptstadt werden deshalb zwei Flugzeuge vom Typ A320 stationiert.\n                                                "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                Im aktuellen Winterflugplan hebt die Fluggesellschaft nach Fuerteventura, Gran Canaria und Teneriffa ab. Mit Hurghada und Marsa Alam haben Erholungssuchende zudem zwei sonnenreiche Alternativen, die mit SUNDAIR ab Dresden nonstop erreichbar sind.\n                                                "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                Götz Ahmelmann, Vorstandsvorsitzender der Mitteldeutschen Flughafen AG, betont: "
                    ),
                    _c("i", [
                      _vm._v(
                        '„Erst im Mai dieses Jahres hat SUNDAIR eine Basis am Flughafen Dresden eröffnet und wird mit einem weiteren hier stationierten Airbus sein Engagement ausbauen.\n                                                Es freut uns sehr, dass Korfu nun ein schnelles Comeback im Dresdner Flugplan erlebt und damit auch im Sommer 2020 eines der beliebtesten griechischen Urlaubsziele nonstop erreichbar ist."'
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("br"),
                  _c("b", [
                    _vm._v(
                      "SUNDAIR-Verbindungen ab Dresden in der Wintersaison 2019/20"
                    ),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("table", { staticStyle: { width: "100%" } }, [
                    _c("tr", [
                      _c("td", [_vm._v("04.11.2019")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("20.04.2020")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Montag")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Fuerteventura")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("03.11.2019")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("26.04.2020")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Sonntag")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Gran Canaria")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            05.11.2019"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            07.11.2019"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            02.11.2019\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            28.04.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            30.04.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            18.04.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Dienstag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Donnerstag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Samstag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Hurghada")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("07.02.2020")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("17.04.2020")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Freitag")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Marsa Alam")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("06.11.2019")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("15.04.2020")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Mittwoch")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Teneriffa")]),
                    ]),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _c("br"),
                  _c("b", [
                    _vm._v(
                      "SUNDAIR-Verbindungen ab Dresden in der Sommersaison 2020"
                    ),
                  ]),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c("table", { staticStyle: { width: "100%" } }, [
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            05.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            01.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            03.05.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            27.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            30.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            01.11.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Dienstag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Freitag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Sonntag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Antalya")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            07.05.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            29.10.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Donnerstag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Fuerteventura")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            04.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            06.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            01.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            03.05.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            26.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            28.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            30.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            01.11.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Montag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Mittwoch"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Freitag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Sonntag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Heraklion (Kreta)")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            05.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            02.05.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            27.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            31.10.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Dienstag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Samstag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Hurghada")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            07.05.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            27.10.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Dienstag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Korfu")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            07.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            03.05.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            29.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            01.11.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Donnerstag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Sonntag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Kos")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            05.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            07.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            02.05.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            27.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            29.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            31.10.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Dienstag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Donnerstag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Samstag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Palma de Mallorca")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            05.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            07.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            02.05.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            27.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            29.10.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            31.10.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Dienstag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Donnerstag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Samstag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Rhodos")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                                            18.05.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            06.06.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            24.08.2020"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            26.09.2020\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                                            Montag"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                                            Samstag\n                                                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "vertical-align": "text-top" } },
                        [_vm._v("Varna (Bulgarien)")]
                      ),
                    ]),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("p"),
                  _c("br"),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("18.11.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_9.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v("SUNDAIR mit Zusatzprogramm ab Düsseldorf"),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 06.09.2019 ")]),
                    _vm._v(
                      " – Auch in diesem Jahr startet SUNDAIR über Weihnachten und Silvester\n                                                ein Zusatzprogramm ab Düsseldorf. Reisende können aus der Hauptstadt Nordrhein-Westfalens mit SUNDAIR nach Fuerteventura, Gran Canaria und Teneriffa auf den Kanarischen\n                                                Inseln aufbrechen. Die Inseln des ewigen Frühlings erwarten die Urlaubsgäste mit\n                                                angenehmen Temperaturen, langen Sandstränden sowie abwechslungsreicher Natur und\n                                                bieten den idealen Ausgangspunkt für den Erholungs- oder Aktivurlaub. Im Zeitraum vom\n                                                21.12.2019 bis einschließlich 05.01.2020 wird die Stralsunder Airline für das Zusatzprogramm\n                                                einen A320 am Flughafen Düsseldorf stationieren. Insgesamt startet SUNDAIR im Zeitraum des\n                                                Zusatzprogramms zu 11 Abflügen in Düsseldorf. Neben drei tollen Destinationen können sich\n                                                die Urlaubsgäste mit SUNDAIR auf eine zuverlässige Airline, 20 kg Freigepäck sowie sehr guten\n                                                Service an Bord freuen."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Alle Termine sind bereits im Reisebüro oder unter "
                    ),
                    _c("a", { attrs: { href: "https://www.sundair.com" } }, [
                      _vm._v("www.sundair.com"),
                    ]),
                    _vm._v(" buchbar."),
                    _c("br"),
                    _c("br"),
                  ]),
                  _c("br"),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("06.09.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_7.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "Mehr Urlaubsflüge und neue Strecken: SUNDAIR baut Angebot ab Dresden aus"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 23.08.2019 ")]),
                    _vm._v(
                      " – Die Fluggesellschaft SUNDAIR verstärkt ihr Engagement am Flughafen\n                                                Dresden. Im Sommer 2020 stationiert die Airline ein zweites\n                                                Flugzeug und steuert auch Palma de Mallorca und Varna an.\n                                                Außerdem stehen erstmals die Urlaubsziele Fuerteventura und\n                                                Hurghada im Sommerflugplan. Erholungssuchende können des\n                                                Weiteren nach Antalya, Heraklion, Kos und Rhodos fliegen. Dadurch\n                                                steigt die Anzahl der wöchentlichen Starts und Landungen von\n                                                SUNDAIR am Dresdner Airport von 28 auf 40. Für die zusätzlichen\n                                                Flüge kommt ein Airbus A320 zum Einsatz. Die neuen Angebote sind\n                                                bereits buchbar. "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "“Mit neuen Zielen und der Stationierung einer zweiten Maschine am\n                                                Standort Dresden, erweitern wir die Angebotsvielfalt für unsere Passagiere.\n                                                Mit SUNDAIR bieten wir den Reisenden eine zuverlässige Airline mit sehr\n                                                gutem Service. Wir freuen uns bereits jetzt auf die kommende\n                                                Sommersaison in Dresden und auf viele zufriedene Gäste”"
                      ),
                    ]),
                    _vm._v(
                      ", so Marcos\n                                                Rossello, Geschäftsführer der SUNDAIR."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Götz Ahmelmann, Vorstandsvorsitzender der Mitteldeutschen Flughafen\n                                                AG, betont: "
                    ),
                    _c("i", [
                      _vm._v(
                        "“Im Einzugsgebiet des Flughafens Dresden gibt es eine große\n                                                Nachfrage nach touristischen Flügen. Wir freuen uns, dass SUNDAIR dieses\n                                                Potenzial nutzt und an unserem Standort die Angebote bereits wenige\n                                                Monate nach der Basis-Eröffnung ausbaut. Für Urlauber ergibt sich dadurch\n                                                eine größere Auswahl an Zielen sowie eine flexiblere Reiseplanung.”"
                      ),
                    ]),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Anfang Mai 2019 eröffnete SUNDAIR eine Basis am Flughafen Dresden und\n                                                stationierte einen Airbus A320. Damit bringt die Airline aktuell jede Woche\n                                                Passagiere nach Heraklion, Rhodos, Kos und Antalya."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Im Winterflugplan, der Ende Oktober beginnt, steuert die Fluggesellschaft\n                                                Fuerteventura, Gran Canaria und Teneriffa an. Mit Hurghada und Marsa\n                                                Alam haben Erholungssuchende zudem zwei sonnenreiche Alternativen, die\n                                                mit SUNDAIR ab Dresden nonstop erreichbar sind."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _c("b", [
                      _vm._v(
                        "SUNDAIR-Verbindungen ab Dresden in der Wintersaison 2019/20"
                      ),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("table", { staticStyle: { width: "100%" } }, [
                      _c("tr", [
                        _c("td", [_vm._v("04.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("20.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Montag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Fuerteventura")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("03.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("26.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Sonntag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Gran Canaria")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                                                            05.11.2019"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            07.11.2019"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            02.11.2019\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            28.04.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            30.04.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            18.04.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Dienstag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Donnerstag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Samstag\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "vertical-align": "text-top" } },
                          [_vm._v("Hurghada")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("07.02.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("17.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Freitag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Marsa Alam")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("06.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("15.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Mittwoch")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Teneriffa")]),
                      ]),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _c("br"),
                    _c("b", [
                      _vm._v(
                        "SUNDAIR-Verbindungen ab Dresden in der Sommersaison 2020"
                      ),
                    ]),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("table", { staticStyle: { width: "100%" } }, [
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                                                            05.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            01.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            03.05.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            27.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            30.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            01.11.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Dienstag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Freitag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Sonntag\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "vertical-align": "text-top" } },
                          [_vm._v("Antalya")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                                                            07.05.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            29.10.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Donnerstag\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "vertical-align": "text-top" } },
                          [_vm._v("Fuerteventura")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                                                            04.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            06.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            01.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            03.05.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            26.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            28.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            30.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            01.11.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Montag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Mittwoch"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Freitag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Sonntag\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "vertical-align": "text-top" } },
                          [_vm._v("Heraklion (Kreta)")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                                                            05.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            02.05.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            27.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            31.10.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Dienstag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Samstag\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "vertical-align": "text-top" } },
                          [_vm._v("Hurghada")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                                                            07.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            03.05.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            29.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            01.11.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Donnerstag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Sonntag\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "vertical-align": "text-top" } },
                          [_vm._v("Kos")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                                                            05.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            07.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            02.05.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            27.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            29.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            31.10.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Dienstag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Donnerstag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Samstag\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "vertical-align": "text-top" } },
                          [_vm._v("Palma de Mallorca")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                                                            05.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            07.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            02.05.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            27.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            29.10.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            31.10.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Dienstag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Donnerstag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Samstag\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "vertical-align": "text-top" } },
                          [_vm._v("Rhodos")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                                                            18.05.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            06.06.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            24.08.2020"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            26.09.2020\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Montag"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Samstag\n                                                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "vertical-align": "text-top" } },
                          [_vm._v("Varna (Bulgarien)")]
                        ),
                      ]),
                    ]),
                    _c("br"),
                  ]),
                  _c("br"),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("23.08.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_8.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "SUNDAIR präsentiert Sommerziele 2020 ab Bremen-Airport"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 15.08.2019 ")]),
                    _vm._v(
                      " – Gut zwei Wochen vor dem Erstflug und der Stationseröffnung in\n                                                Bremen, präsentiert die Stralsunder Airline SUNDAIR ihren Sommerflugplan ab Bremen-Airport.\n                                                Mit Zielen rund um das westliche sowie östliche Mittelmeer und am Atlantischen Ozean, bietet\n                                                die junge Airline Urlaubern eine breite Vielfalt an Möglicheiten für die Reiseplanung. Mit vier\n                                                wöchentlichen Abflügen (montags, mittwochs, freitags und sonntags) bringt SUNDAIR Reisende\n                                                aus Bremen und der Region direkt auf die beliebteste deutsche Baleareninsel, Palma de\n                                                Mallorca. Im östlichen Mittelmeer bedient SUNDAIR mit Heraklion auf Kreta, den griechischen\n                                                Inseln Rhodos und Kos, sowie auch Antalya in der Türkei insgesamt vier Ziele in zwei Ländern.\n                                                Die Urlaubsgäste erreichen die größte Ferieninsel Griechenlands Kreta dreimal wöchentlich\n                                                mit SUNDAIR ab Bremen. Jeden Dienstag und Samstag hebt der SUNDAIR Airbus A320 ebenfalls\n                                                in Richtung der Sonneninsel Rhodos ab. Auch die schöne griechische Destination Kos wird ab\n                                                Mai 2020 wöchentlich mit zwei Abflügen durch die Stralsunder Airline vom norddeutschen\n                                                Bremen-Airport angeboten. Abgerundet wird das Destinationsportfolio im östlichen Mittelmeer\n                                                von Antalya in der Türkei mit jeweils einem wöchentlichen Flug. Ebenfalls im Programm findet\n                                                sich auch die Kanarische Insel Fuerteventura, welche Reisende jeweils montags und freitags\n                                                direkt von Bremen aus erreichen.  "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Wir freuen uns auf unsere erste ganzheitliche Sommersaison ab Bremen und bieten den\n                                                Reisenden ein vielfältiges Portfolio an Destinationen für ihren Urlaub. Dazu können sich die\n                                                Bremerinnen und Bremer auf eine zuverlässige Airline, guten Service, sowie 20kg Freigepäck\n                                                freuen“"
                      ),
                    ]),
                    _vm._v(
                      ", so Marcos Rossello, Geschäftsführer der SUNDAIR."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Und Flughafen-Chef Elmar Kleinert ergänzt: "
                    ),
                    _c("i", [
                      _vm._v(
                        "„SUNDAIR fliegt kommenden Sommer ab Bremen\n                                                sechs Ziele in beliebten Urlaubsregionen an, von Antalya bis Rhodos sind hier tolle\n                                                Destinationen im Programm. Wir hoffen, dass aus diesen gelungenen Anfängen eine\n                                                langjährige und starke Partnerschaft zwischen SUNDAIR und Bremen Airport entsteht.“"
                      ),
                    ]),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _c("b", [
                      _vm._v("SUNDAIR Sommerflugplan 2020 ab Bremen Airport "),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("table", { staticStyle: { width: "100%" } }, [
                      _c("tr", [
                        _c("td", [_vm._v("04.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("26.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Montag")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Bremen – Palma de Mallorca - Bremen"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Bremen – Fuerteventura - Bremen\n                                                        "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("05.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("27.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dienstag")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Bremen – Heraklion – Bremen"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Bremen – Rhodos - Bremen\n                                                        "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("06.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("28.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Mittwoch")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Bremen – Palma de Mallorca – Bremen"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Bremen – Kos – Bremen\n                                                        "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("07.05.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("29.10.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Donnerstag")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Bremen – Heraklion – Bremen"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Bremen – Antalya – Bremen\n                                                        "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("01.05.2020  ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("30.10.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Freitag")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Bremen – Palma de Mallorca – Bremen"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Bremen – Fuerteventura – Bremen\n                                                        "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("02.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("31.10.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Samstag")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Bremen – Heraklion – Bremen"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Bremen – Rhodos – Bremen\n                                                        "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("03.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("25.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Sonntag")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                                            Bremen – Palma de Mallorca – Bremen"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                                                            Bremen – Kos - Bremen\n                                                        "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("br"),
                  ]),
                  _c("br"),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("15.08.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_6.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "SUNDAIR veröffentlicht Sommerflugplan 2020 ab Kassel"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 09.08.2019 ")]),
                    _vm._v(
                      " – – Noch während des aktuell laufenden Sommerflugplans präsentiert die\n                                                junge Stralsunder Airline ihre Sonnenstrecken für den Sommer 2020. Mit diesem Angebot\n                                                bietet SUNDAIR nunmehr in der dritten Sommersaison Reisenden aus Kassel und der Region\n                                                die Möglichkeit, direkt von Zuhause in den Urlaub zu starten. Mit Destinationen am Mittelmeer,\n                                                an dem Roten Meer sowie am Atlantischen Ozean, können Urlauber aus einer breiten Vielfalt\n                                                an Möglichkeiten für ihren Sommerurlaub wählen. Mit vier wöchentlichen Abflügen (montags,\n                                                mittwochs, freitags und sonntags) bringt SUNDAIR ihre Gäste direkt auf die beliebteste deutsche\n                                                Ferieninsel, Palma de Mallorca. Auch die bekannten griechischen Urlaubsziele Rhodos und\n                                                Heraklion werden von SUNDAIR im nächsten Sommerprogramm ab Kassel bedient. Reisende\n                                                erreichen die größte Insel Griechenlands, Kreta, jeweils zweimal wöchentlich, dienstags und\n                                                samstags. Jeden Donnerstag verbindet SUNDAIR die Sonneninsel Rhodos direkt mit Kassel. Mit\n                                                Hurghada in Ägypten bietet die Stralsunder Airline ein weiteres interessantes Reiseziel,\n                                                welches Urlauber mit seinen durchgehend sommerlichen Temperaturen als Bade- und\n                                                Tauchparadies erwartet. Mit SUNDAIR geht es ab Mai 2020 immer donnerstags von Kassel nach\n                                                Hurghada. Ebenfalls in der Routenvielfalt der Airline findet sich die Kanarische Insel\n                                                Fuerteventura, welche Reisende immer freitags ab Kassel erreichen können."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Der Sommerflugplan bietet unseren Gästen ab Kassel wieder einmal zahlreiche\n                                                Möglichkeiten für Ihren Urlaub: Von Aktivurlaub bis Erholung am Strand. Dazu können sich\n                                                unsere Gäste auf den gewohnt guten SUNDAIR-Service freuen und entspannt in ihren Urlaub\n                                                starten“"
                      ),
                    ]),
                    _vm._v(
                      ", so Marcos Rossello, Geschäftsführer der SUNDAIR."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _c("b", [
                      _vm._v("SUNDAIR Sommerflugplan 2020 ab Kassel-Airport:"),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("table", { staticStyle: { width: "100%" } }, [
                      _c("tr", [
                        _c("td", [_vm._v("04.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("19.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Montag")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("Kassel – Palma de Mallorca - Kassel"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("05.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("27.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dienstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Kassel – Heraklion - Kassel")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("06.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("28.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Mittwoch")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("Kassel – Palma de Mallorca - Kassel"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("07.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("29.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Donnerstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Kassel – Rhodos - Kassel")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("07.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("29.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Donnerstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Kassel – Hurghada - Kassel")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("01.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("30.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Freitag")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("Kassel – Palma de Mallorca - Kassel"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("03.07.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("30.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Freitag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Kassel – Fuerteventura - Kassel")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("02.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("31.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Samstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Kassel – Heraklion - Kassel")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("03.05.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("25.10.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Sonntag")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v("Kassel – Palma de Mallorca - Kassel"),
                        ]),
                      ]),
                    ]),
                    _c("br"),
                  ]),
                  _c("br"),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("09.08.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_5.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v("SUNDAIR präsentiert Winterziele ab Dresden"),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 19.07.2019 ")]),
                    _vm._v(
                      " – Anfang Mai startete SUNDAIR erstmals von ihrer neu eröffneten Basis in Dresden mit einem Flug\n                                                auf die griechische Insel Kos. Seither hat die junge Stralsunder Airline mit Heraklion, Rhodos und Antalya weitere Sommerdestinationen\n                                                in ihr Streckennetz aufgenommen. Am 27. Oktober startet der Winterflugplan am Flughafen Dresden und SUNDAIR verbindet die sächsische\n                                                Landeshauptstadt mit den Urlaubszielen Fuerteventura, Gran Canaria, Teneriffa, Hurghada und Marsa Alam. "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Auf den Kanarischen Inseln erwartet die Reisenden ganzjährig angenehme Temperaturen, tolle Landschaften sowie endlos lange Badestrände.\n                                                Mit SUNDAIR erreichen Urlauber ab Dresden je einmal wöchentlich die Insel der Vielfalt Gran Canaria, die Sonneninsel Fuerteventura,\n                                                sowie die größte Insel der Kanaren Teneriffa. Das Rote Meer besticht als Bade- und Tauchparadies vor allem durch die durchgehend\n                                                sommerlichen Temperaturen sowie den traumhaften Stränden und dem türkisblauen Meer. Auch Freunde des Tauchsports kommen beim\n                                                Entdecken der vielfältigen Korallenriffe voll auf ihre Kosten. SUNDAIR fliegt Urlauber im Winterflugplan dreimal wöchentlich von\n                                                Dresden nach Hurghada. Ab Februar 2020 ergänzt je ein wöchentlicher Flug nach Marsa Alam das Destinationsportfolio der Airline in Ägypten."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Nach dem sehr guten Start in Dresden seit unserer Stationseröffnung am 1. Mai in diesem Jahr, freuen wir uns auf eine ebenso erfolgreiche Wintersaison am\n                                                Flughafen mit vielen zufriedenen Gästen, die mit SUNDAIR in ihren Urlaub starten. Unser Destinationsportfolio bietet den Reisenden eine breite Vielfalt\n                                                an Möglichkeiten: Von Erholung am Strand bis zu einem Aktivurlaub mit Wanderungen oder Tauchgängen“"
                      ),
                    ]),
                    _vm._v(
                      ", so Marcos Rossello, Geschäftsführer der SUNDAIR."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Götz Ahmelmann, Vorstandsvorsitzender der Mitteldeutschen Flughafen AG und Geschäftsführer der Flughäfen Dresden und Leipzig/Halle, betont:\n                                                "
                    ),
                    _c("i", [
                      _vm._v(
                        "„Die Kanaren zählen am Flughafen Dresden seit vielen Jahren zu den beliebtesten Winterzielen. Umso mehr freut es mich, dass nach einer kurzen Unterbrechung Fuerteventura,\n                                                Gran Canaria und Teneriffa wieder im Flugplan stehen. Mit Hurghada und Marsa Alam haben Erholungssuchende zudem zwei sonnenreiche Alternativen, die mit unserem\n                                                Partner SUNDAIR nonstop ab Dresden erreichbar sind.“"
                      ),
                    ]),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _c("b", [
                      _vm._v(
                        "SUNDAIR Winterflugplan 2019/2020 ab dem Flughafen Dresden:"
                      ),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("table", { staticStyle: { width: "100%" } }, [
                      _c("tr", [
                        _c("td", [_vm._v("04.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("20.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Montag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dresden – Fuerteventura – Dresden")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("05.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("28.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dienstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dresden – Hurghada – Dresden")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("06.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("15.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Mittwoch")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dresden – Teneriffa – Dresden")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("07.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("30.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Donnerstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dresden – Hurghada – Dresden")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("07.02.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("17.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Freitag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dresden – Marsa Alam – Dresden")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("02.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("18.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Samstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dresden – Hurghada – Dresden")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("03.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("26.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Sonntag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dresden – Gran Canaria - Dresden")]),
                      ]),
                    ]),
                    _c("br"),
                  ]),
                  _c("br"),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("19.07.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_4.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v("SUNDAIR präsentiert Flugprogramm ab Bremen"),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 17.05.2019  ")]),
                    _vm._v(
                      " – Die Stralsunder Fluggesellschaft SUNDAIR stationiert zum Spätsommer\n                                                2019 einen Airbus A320 am Bremen Airport und bietet Gästen in und um Bremen die\n                                                Möglichkeit, bequem in ihren Urlaub zu starten. Der Erstflug ab Bremen findet am 31. August\n                                                2019 statt und bringt Reisende auf die griechische Urlaubsinsel Rhodos. Anschließend werden\n                                                bis zum Beginn des Winterflugplans die beliebten Ferienziele Mallorca, Kreta und Antalya und\n                                                auf den Kanarischen Inseln Gran Canaria und Fuerteventura angeflogen. Ab November startet\n                                                SUNDAIR zweimal wöchentlich nach Hurghada in Ägypten. Ab Februar ergänzt Marsa Alam\n                                                zusätzlich das Destinationsportfolio der Airline am Roten Meer. Ergänzend zum Angebot in\n                                                Ägypten bedient SUNDAIR ebenfalls mit je einem wöchentlichen Flug die beliebten Winterziele\n                                                Teneriffa, Gran Canaria sowie Fuerteventura auf den Kanarischen Inseln. Die spanische\n                                                Ferieninsel Fuerteventura ist zudem ab Februar 2020 mit zwei wöchentlichen Flügen zu\n                                                erreichen. Insgesamt sind bis zu 22 Starts und Landungen pro Woche ab Bremen Airport\n                                                geplant. "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Wir freuen uns nach Berlin, Kassel und Dresden nun auch in Bremen zu starten und Reisende\n                                                in den Urlaub zu fliegen. Die starke Nachfrage in Bremen hat uns darin bestärkt, unser\n                                                Engagement auch im nächsten Sommer fortzusetzen und weiter auszubauen. Unsere Gäste\n                                                können sich auf tolle Urlaubsziele am Mittelmeer, am Roten Meer sowie am Atlantischen\n                                                Ozean freuen. Dazu gibt es natürlich den guten SUNDAIR Service, den die Kunden von uns\n                                                kennen“"
                      ),
                    ]),
                    _vm._v(
                      ", so Marcos Rossello, Geschäftsführer der SUNDAIR."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Flughafen-Geschäftsführer Elmar Kleinert ergänzt: "
                    ),
                    _c("i", [
                      _vm._v(
                        "„Wir freuen uns, mit SUNDAIR eine neue Airline am Bremen Airport im Angebot\n                                                zu haben, die in Bremen ihr Engagement über die kommenden Jahre ausbauen will und bei\n                                                uns ab Herbst ein Flugzeug stationiert. Somit haben wir beispielsweise die Kanarischen Inseln\n                                                ab Spätsommer und auch im kommenden Winterflugplan im Programm.“"
                      ),
                    ]),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _c("b", [
                      _vm._v(
                        "SUNDAIR Winterflugplan 2019/2020 ab Bremen Airport:"
                      ),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("table", { staticStyle: { width: "100%" } }, [
                      _c("tr", [
                        _c("td", [_vm._v("04.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("20.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Montag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Bremen – Hurghada – Bremen")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("05.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("19.11.2019 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dienstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Bremen – Antalya – Bremen")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("04.02.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("14.04.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Dienstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Bremen – Fuerteventura – Bremen")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("06.11.2019 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("15.04.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Mittwoch")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Bremen – Teneriffa – Bremen")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("07.11.2019 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("30.04.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Donnerstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Bremen – Hurghada – Bremen")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("01.11.2019 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("22.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Freitag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Bremen – Antalya – Bremen")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("07.02.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("17.04.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Freitag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Bremen – Marsa Alam – Bremen")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("02.11.2019")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("25.04.2020")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Samstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Bremen – Fuerteventura – Bremen")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("03.11.2019 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("19.04.2020 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Sonntag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Bremen – Gran Canaria – Bremen")]),
                      ]),
                    ]),
                    _c("br"),
                  ]),
                  _c("br"),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("17.05.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_3.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "Neue Basis in Dresden: SUNDAIR startet Tourismusprogramm"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 1.Mai 2019 ")]),
                    _vm._v(
                      " – Mit einer voll besetzten Maschine startete die Stralsunder Airline heute\n                                                    erstmals von Dresden auf die griechische Urlaubsinsel Kos. Zeitgleich wurde nach BerlinTegel und Kassel-Calden auch die dritte deutsche Basis von SUNDAIR eröffnet. Unter\n                                                    Wasserfontänen der Dresdner Flughafenfeuerwehr verließ der Airbus A320 den Flughafen\n                                                    pünktlich um 13.45 Uhr. Die traumhaften Sandstrände und das Mittelmeerklima machen Kos\n                                                    in der Sommersaison zu einem attraktiven Urlaubsziel. In rund drei Stunden ist die griechische\n                                                    Urlaubsinsel zukünftig jeweils mittwochs und samstags von Dresden erreichbar. Nunmehr\n                                                    haben Urlauber aus der sächsischen Landeshauptstadt und ihrem Umland die Möglichkeit,\n                                                    ganz bequem in den Urlaub zu starten. Insgesamt sind im Sommerflugplan bis zu 30 Starts\n                                                    und Landungen pro Woche ab Dresden geplant. Neben den griechischen Inseln Kos, Kreta\n                                                    und Rhodos umfasst der Sommerflugplan der SUNDAIR ebenfalls Antalya in der Türkei."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Wir freuen uns, mit dem heutigen Erstflug unsere neue Station zu eröffnen und nun auch vom\n                                                    Flughafen Dresden in den Sommerflugplan zu starten. Mit unseren Flügen in Richtung\n                                                    Griechenland und in die Türkei bieten wir Urlaubern ein attraktives Reiseportfolio für ihren\n                                                    Sommerurlaub“ "
                      ),
                    ]),
                    _vm._v(
                      ", so Marcos Rossello, Geschäftsführer der SUNDAIR."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                    Götz Ahmelmann, Vorstandsvorsitzender der Mitteldeutschen Flughafen AG und Vorsitzender\n                                                    der Geschäftsführung der Flughäfen Dresden und Leipzig/Halle, ergänzt:\n                                                    "
                    ),
                    _c("i", [
                      _vm._v(
                        "„Ich freue mich, dass SUNDAIR das touristische Angebot an unserem Airport erweitert und\n                                                    wünsche unserem Partner allzeit guten Flug.“ "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("01.05")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_2.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "Sommerflugplan startet am Kassel Airport zum Beginn der Osterferien"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "SUNDAIR stationiert ein Flugzeug am Flughafen Bremen und schließt weitere Lücken im Flugplan"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Kassel, 15. April 2019")]),
                    _vm._v(
                      " –– Pünktlich zum Beginn der hessischen Osterferien startet am Kassel\n                                                Airport der Sommerflugplan mit einigen Zielen: Seit dem 14.04 geht es bereits zweimal\n                                                wöchentlich nach Palma/Mallorca (montags und sonntags). Ab Ende April kommen noch\n                                                drei weitere Verbindungen hinzu (mittwochs, donnerstags und freitags). Insgesamt bietet\n                                                die Airline SUNDAIR im Sommer 5 wöchentliche Verbindungen ab Kassel auf die beliebte\n                                                Ferieninsel an."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Auch Griechenland-Fans kommen bereits jetzt an ihr Ziel und erreichen Heraklion auf\n                                                Kreta seit dem Ferienstart mit SUNDAIR zweimal wöchentlich (dienstags und samstags)."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Ab Mai können Reisende neu mit SUNDAIR bis zu zweimal wöchentlich nach Antalya reisen\n                                                sowie ganzjährig nach Hurghada in Ägypten und Fuerteventura auf den Kanarischen\n                                                Inseln. "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Wir freuen uns auch in diesem Sommer Urlaubern ab dem Kassel Airport ein attraktives\n                                                Reiseangebot anbieten zu können. Die anhaltende Nachfrage ermöglicht es uns, unseren\n                                                Flugplan um eine zusätzliche Frequenz auf insgesamt fünf wöchentliche Flüge in Richtung\n                                                Palma/Mallorca zu ergänzen. Mit unserer neuen Verbindung nach Antalya erweitern wir\n                                                ebenfalls unsere Streckenvielfalt ab Kassel“"
                      ),
                    ]),
                    _vm._v(", so "),
                    _c("b", [
                      _vm._v(
                        "Marcos Rossello, Geschäftsführer SUNDAIR\n                                                GmbH"
                      ),
                    ]),
                    _vm._v("."),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                                Sonnenhungrige Nordhessen verlängern jetzt schon ihren Sommer auch im nächsten\n                                                Winter und starten ab Kassel direkt in den Sonnen-Urlaub: Die ersten Angebote für den\n                                                Winter 2019/2020 sind veröffentlicht und buchbar. Mit SUNDAIR geht es von November bis\n                                                April zweimal wöchentlich nach Hurghada/Ägypten (donnerstags und samstags) sowie\n                                                jeweils einmal wöchentlich nach Teneriffa (mittwochs) und Gran Canaria (sonntags)."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        "Lars Ernst, Geschäftsführer Flughafen GmbH Kassel:"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Wir freuen uns sehr, dass die Ziele\n                                                für den kommenden Winter so früh buchbar sind, um den Urlaubern eine langfristige\n                                                Planung zu ermöglichen und das ein oder andere Reise-Schnäppchen zu ergattern. Die\n                                                Reiseziele haben sich im letzten Winter bewährt und wir freuen uns, dass die Nachfrage\n                                                in der Region weiter anhält. Auch im Winter wird somit wieder ein entspannter und\n                                                bequemer Start in den Urlaub direkt ab Kassel möglich sein.“"
                      ),
                    ]),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        "Der vorläufige Winterflugplan 2019/2020 ab Kassel im Detail:"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("table", { staticStyle: { width: "100%" } }, [
                      _c("tr", [
                        _c("td", [_vm._v("06.11.19 bis 15.04.20 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Mittwoch")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Kassel – Teneriffa - Kassel")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("07.11.19 bis 30.04.20 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Donnerstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Kassel – Hurghada - Kassel")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("02.11.19 bis 25.04.20 ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Samstag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Kassel – Hurghada - Kassel")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("03.11.19 bis 19.04.20  ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Sonntag")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Kassel – Gran Canaria - Kassel")]),
                      ]),
                    ]),
                    _c("br"),
                    _vm._v(
                      "\n                                                Den Flugplan und weitere Informationen finden Sie auch unter "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "http://www.kassel-airport.aero",
                          target: "_new",
                        },
                      },
                      [_vm._v("www.kassel-airport.aero")]
                    ),
                    _c("br"),
                    _c("br"),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("15.04.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_1.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "Mit SUNDAIR ab Spätsommer 2019 vom Bremen Airport in den Urlaub"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "SUNDAIR stationiert ein Flugzeug am Flughafen Bremen und schließt weitere Lücken im Flugplan"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 13. Februar 2019")]),
                    _vm._v(
                      " – Nach Veröffentlichung der Stationierung eines Flugzeuges am\n                                                Flughafen Dresden kündigt die junge deutsche Airline nun eine weitere Basis am Bremen\n                                                Airport an. Mit der Stationierung eines Flugzeuges vom Typ Airbus A320 bietet SUNDAIR den\n                                                Urlaubern aus Bremen und dem angrenzenden Niedersachsen die Möglichkeit bequem in\n                                                ihren Urlaub zu starten. Der Erstflug ab Bremen findet am 31. August auf die griechische Insel\n                                                Rhodos statt. Die Stralsunder Fluggesellschaft startet anschließend ihre Flüge zu den\n                                                Ferienzielen Mallorca, Kreta, Rhodos und Antalya im Mittelmeer sowie Gran Canaria und\n                                                Fuerteventura auf den Kanarischen Inseln. Insgesamt sind für den Spätsommer 22 Starts und\n                                                Landungen pro Woche ab Bremen Airport geplant."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                Marcos Rossello, Geschäftsführer der Airline, freut sich auf den neuen Standort und das\n                                                SUNDAIR nur wenige Jahre nach der Gründung bereits in so vielen Ecken Deutschlands Flagge\n                                                zeigt. "
                    ),
                    _c("i", [
                      _vm._v(
                        "„Wir freuen uns, nach dem erfolgreichen Start in Berlin und Kassel, sowie nach der\n                                                Ankündigung unserer Station in Dresden, nun auch Gäste aus dem Norden in ihren Urlaub zu\n                                                befördern und sie von unserem guten Service überzeugen zu können“"
                      ),
                    ]),
                    _vm._v(", so Rossello."),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                Alle Pauschalreisen mit SUNDAIR ab Bremen sind ab sofort buchbar.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("13.02.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_1.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v("SUNDAIR fliegt für TUI fly"),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 11. Februar 2019")]),
                    _vm._v(
                      " – Die junge Fluggesellschaft SUNDAIR startet im Auftrag der TUI fly ab Frühjahr 2019 vom Flughafen Karlsruhe / Baden-Baden (FKB)."
                    ),
                    _c("br"),
                  ]),
                  _c("p", [
                    _vm._v(
                      "\n                                                Die Stralsunder Airline wird in der diesjährigen Sommersaison ein Flugzeug für TUI fly, der deutschen\n                                                Airline des weltweit führenden Reiseveranstalters TUI, am Flughafen Karlsruhe / Baden-Baden (FKB)\n                                                stationieren. Bei der Maschine handelt es sich um eines der beiden Flugzeuge vom Typ Airbus A319\n                                                mit einer Kapazität von 150 Sitzplätzen, die in diesem Jahr die SUNDAIR Flotte erweitern. Der Flugbetrieb\n                                                ab dem FKB wird am 24. Mai 2019 aufgenommen und umfasst zunächst die komplette Sommersaison\n                                                2019.\n                                                "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Ab dem Sommer haben TUI Gäste zwischen Schwarzwald und Pfalz wieder direkten Zugang zu den\n                                                schönsten Stränden Griechenlands, der Kanaren, Ägyptens oder Mallorcas. Wir freuen uns mit SUNDAIR\n                                                einen zuverlässigen Partner gefunden zu haben, der mit uns die Sommersonnenziele anfliegen wird“"
                      ),
                    ]),
                    _vm._v(
                      ",\n                                                sagt Oliver Lackmann, Geschäftsführer der TUIfly GmbH.\n                                                "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                Im Auftrag der TUI fly wird SUNDAIR Urlauber ab Karlsruhe / Baden-Baden (FKB) nach Palma de Mallorca,\n                                                Heraklion, Kos, Rhodos, Hurghada sowie nach Gran Canaria, Fuerteventura und Teneriffa befördern.\n                                                An Bord erwartet die Gäste das gerade erweiterte Cateringangebot der TUI fly, welches neben\n                                                vorbestellbaren Menüs aus dem TUI fly Bistro auch ein breit gefächertes Angebot an Speisen und\n                                                Getränken im TUI fly Café bietet. Weitere Informationen hierzu erhalten Passagiere unter:\n                                                "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.tuifly.com/de/service/catering.html",
                          target: "_new",
                        },
                      },
                      [
                        _vm._v(
                          "https://www.tuifly.com/de/service/catering.html"
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("11.02.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_1.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "SUNDAIR stellt A320 ab Sommer nach Dresden und schließt große Lücke im Flugplan"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Der Flughafen in Sachsen wird zur neuen Basis der jungen Airline"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 07. Februar 2019")]),
                    _vm._v(
                      " -  – Die plötzliche Germania-Insolvenz hat am Flughafen Dresden eine große Lücke hinterlassen."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                                SUNDAIR wird ab Sommer 2019 vier frühere Ziele der Airline\n                                                anfliegen und dafür sorgen, dass Urlauber aus Dresden und dem Umland ganz bequem und\n                                                wie geplant in den Sommerurlaub starten können."
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                                                SUNDAIR wird die Passagiere mehrmals\n                                                wöchentlich in die sonnigen Ferienziele Kreta, Rhodos, Kos und Antalya fliegen."
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                                                Insgesamt sind pro Woche 26 Starts und Landungen geplant.\n                                                "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                Der Reiseveranstalter schauinsland-reisen, Anteilseigener der SUNDAIR und mit 100-jähriger\n                                                Erfahrung auch für den Vertrieb der Airline verantwortlich, weiß wie wichtig derzeit für alle\n                                                betroffenen Parteien – Reiseveranstalter, Reisebüros, Flughafen und Kunden - die Schaffung\n                                                von „neuen“ Flugverbindungen ist."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        "„Wir freuen uns, dass wir gemeinsam mit der SUNDAIR so\n                                                schnell ab Dresden gute und wichtige Verbindungen für die Touristikbranche und die\n                                                Fluggäste anbieten können. Wir sind uns sicher, dass die SUNDAIR mit ihrem guten Service,\n                                                der hohen Pünktlichkeitsquote und dem Freigepäck von 20 kg auch bald in Sachsen zu den\n                                                Lieblingsairlines der Fluggäste gehören wird“"
                      ),
                    ]),
                    _vm._v(
                      ", so Gerald Kassner, Geschäftsführer von\n                                                schauinsland-reisen."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                Auch Marcos Rossello, Geschäftsführer der SUNDAIR, zeigt sich erfreut\n                                                über die neue Basis. "
                    ),
                    _c("i", [
                      _vm._v(
                        "„Es war uns als neue, deutsche Airline von Anfang an wichtig keine\n                                                Überkapazitäten an irgendeinem Flughafen zu schaffen, sondern Nischen zu bedienen und\n                                                Lücken zu schließen. Mit dem Gang nach Dresden bleiben wir diesem Geschäftsmodell treu\n                                                und werden so weiter wachsen“"
                      ),
                    ]),
                    _vm._v(
                      ", so Rossello.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                                Alle Flüge und Pauschalreisen mit SUNDAIR ab Dresden sind ab sofort buchbar.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("07.02.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_1.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v(
                    "SUNDAIR erweitert die Flotte und wächst auf sechs Maschinen"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 15. Januar 2019")]),
                    _vm._v(
                      " - Die junge Fluggesellschaft SUNDAIR verstärkt auch in diesem Jahr die Flotte um zwei Flugzeuge."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                    SUNDAIR erwartet zu Beginn des Sommerflugplans zwei Maschinen vom Typ A319-111."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                    Für die beiden Flugzeuge wurde mit der Leasinggesellschaft BBAM ein Vertrag über einen Zeitraum\n                                                    von vier Jahren geschlossen."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                    Derzeit operieren die beiden Neuzugänge für Sky Airline. Das erste Flugzeug geht bereits Ende Januar in einen planmäßigen Check und wird nach\n                                                    derzeitigem Planungsstand voraussichtlich im März die SUNDAIR Flotte ergänzen."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                    Der Take-Off des zweiten Flugzeuges ist nach aktuellen Planungen für April vorgesehen.\n                                                    Die Stationierung der beiden Maschinen wird zu einem späteren Zeitpunkt bekannt gegeben.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("15.01.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2019")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_1.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v("Boarding completed for 2018"),
                ]),
                _vm._v(" "),
                _c("h4", [_vm._v("SUNDAIR fliegt mit vier Maschinen")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 14.November 2018")]),
                    _vm._v(
                      " – Die junge Fluggesellschaft SUNDAIR hat im Sommer mit dem Kauf von zwei\n                                                    Flugzeugen vom Typ A320-214 ihre Flotte verdoppelt."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                    Die dritte Maschine mit der Registrierung D-ASGK ist bereits Ende August in den Flugdienst gestartet. Der vierte Airbus, mit der Kennung D-ASMR,\n                                                    wurde am 13. November 2018 in das Luftverkehrsbetreiberzeugnis der SUNDAIR aufgenommen und ist in Berlin-Schönefeld stationiert.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("14.11.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2018")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_1.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v("Neuer Sommerflugplan 2019 ab Kassel"),
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(
                    "Mit SUNDAIR jetzt auch im Sommer nach Fuerteventura und in die Türkei"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("b", [_vm._v("Stralsund, 05. September 2018")]),
                    _vm._v(
                      " – Der neue Sommerflugplan 2019 mit SUNDAIR ab Kassel\n                                                    Airport steht größtenteils fest. SUNDAIR fliegt ab Mai nach Mallorca, Kreta, Ägypten und\n                                                    ganz neu im Sommer auch nach Fuerteventura und in die Türkei.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                                    Die Flüge sind ab sofort im Reisebüro buchbar.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                                    Sonnenhungrige Urlauber können sich auf einen abwechslungsreichen Sommerflugplan 2019\n                                                    mit neuen Zielgebieten ab Kassel Airport freuen.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                                „Bei dem neuen Sommerflugplan handelt es sich um ein umfangreiches Basisprogramm, das wir frühzeitig für Reisebüros und Kunden\n                                                buchbar machen möchten“, so SUNDAIR-Geschäftsführer Marcos Rossello."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                SUNDAIR fliegt von Mai bis Oktober viermal wöchentlich nach Mallorca (montags, mittwochs,\n                                                freitags, sonntags), zweimal wöchentlich nach Heraklion auf Kreta (dienstags und samstags)\n                                                sowie zweimal wöchentlich nach Hurghada in Ägypten (donnerstags und sonntags)."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n                                                Neu im Sommer sind Flüge in die Zielgebiete Fuerteventura (freitags) und zweimal wöchentlich nach Antalya in der Türkei (mittwochs und samstags).\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("05.09.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2018")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "blog-infinite" }, [
          _c("div", { staticClass: "post" }, [
            _c("div", { staticClass: "post-content-wrapper" }, [
              _c("figure", { staticClass: "image-container" }, [
                _c("img", {
                  attrs: {
                    src: "/res/images/banner-sdr/banner_pressrelease_1.jpg",
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details" }, [
                _c("h2", { staticClass: "entry-title" }, [
                  _vm._v("Zuwachs: SUNDAIR verdoppelt die Flotte"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "excerpt-container" }, [
                  _c("p", [
                    _c("strong", [
                      _vm._v("Berlin / Stralsund – 13. Juni 2018"),
                    ]),
                    _vm._v(
                      " – SUNDAIR hat zwei Flugzeuge vom Typ A320-214 gekauft.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                                Die beiden ehemaligen Maschinen der Air Berlin Gruppe befinden sich derzeit in Budapest, um notwendige Checks zu durchlaufen.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                                Ein Airbus (MSN 2668) war zuletzt unter der Registrierung D-ABHI bekannt. Noch im August soll dieser unter der SUNDAIR-Kennung D-ASGK ab Berlin-Schönefeld operieren.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                                Aufgrund der hohen Nachfrage am Markt wurde entschieden, die Kult-Maschine vorerst mit dem „roten Bauch“ abheben zu lassen und sie zu einem späteren Zeitpunkt in SUNDAIR Farben zu lackieren.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("p", [
                    _vm._v(
                      "\n                                                Der Take-off für das zweite Flugzeug (MSN 2619) mit der zukünftigen Registrierung D-ASMR ist für September 2018 geplant.\n                                                An welchem Flughafen diese Maschine stationiert wird, ist noch offen.\n                                                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Kontakt: "),
                    _c("a", { attrs: { href: "mailto:Presse@SUNDAIR.com" } }, [
                      _vm._v("Presse@SUNDAIR.com"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "post-meta" }, [
                  _c("div", { staticClass: "entry-date" }, [
                    _c("label", { staticClass: "date" }, [_vm._v("13.06.")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "month" }, [_vm._v("2018")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-author fn" }, [
                    _c("i", { staticClass: "icon soap-icon-user" }),
                    _vm._v(
                      " Veröffentlicht von:\n                                                    "
                    ),
                    _c("a", { staticClass: "author", attrs: { href: "#" } }, [
                      _vm._v("SUNDAIR"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entry-action" }, [
                    _c("span", { staticClass: "entry-tags" }, [
                      _c("i", { staticClass: "soap-icon-features" }),
                      _c("span", [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("News")]),
                        _vm._v(", "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Infos")]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }